export class ServerResponse<T> {
    constructor(
        public data: T,
        public message: string,
        public totalListCount: number,
        public stackTrace: string,
        public statusCode: number = 0
    ) { }
}